import axios from 'axios';
import { useEffect, useRef, useState } from 'react';
import { setToken } from '../../features/authSlice';
import { selectTableLayer } from '../../features/layerSlice';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import InfoPanel from '../info/InfoPanel';
import Layers from '../layers/Layers';
import LoadingScreen from '../loading/LoadingScreen';
import Search from '../search/Search';
import { Splitter, SplitterPanel } from 'primereact/splitter';
import Toolbar from '../toolbar/Toolbar';
import './Home.scss';
import MapContainer from '../map/MapContainer';
import PanoramaContainer from '../panorama/PanoramaContainer';
import Table from '../table/Table';
import { useNavigate } from 'react-router-dom';
import Import from '../import/Import';
import Rapor from '../rapor/Rapor';
import { LoginRestApi } from '../../utils/restapi/login';
import { setDataRoles, setFunctionalRoles, setShowLoading, setUser, setZoneRoles } from '../../features/sharedSlice';
import { addLocale, locale } from 'primereact/api';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { setShowInfo } from '../../features/toolbarSlice';
import { Basemap } from '../map/components/Basemap/Basemap';
import { useTranslation } from 'react-i18next';

export const Home = () => {
    const toast = useRef<any>(null);
    const toastSticky = useRef<any>(null);
    const toastInfo = useRef<any>(null);
    let navigate = useNavigate();
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const tableLayer = useAppSelector(selectTableLayer);
    const displayPano = useAppSelector(state => state.toolbarState.showPano);
    const displayImport = useAppSelector(state => state.toolbarState.showImport);
    const displayRapor = useAppSelector(state => state.toolbarState.showRapor);
    const token = useAppSelector(state => state.authState.token);
    const activeLanguage = useAppSelector(state => state.language.activeLanguage);
    const user = useAppSelector(state => state.sharedState.user);
    const showToast: any = useAppSelector(state => state.toolbarState.showInfo)
    const [showToastOnLoad, setShowToastOnLoad] = useState<any>(true);
    const [showWizard1, setShowWizard1] = useState<any>(false);
    const [showWizard2, setShowWizard2] = useState<any>(false);
    const [showWizard3, setShowWizard3] = useState<any>(false);
    const [showWizard4, setShowWizard4] = useState<any>(false);
    const [showWizard5, setShowWizard5] = useState<any>(false);
    const [showWizard6, setShowWizard6] = useState<any>(false);

    useEffect(() => {
        const currentURL = window.location.href;
        if (currentURL.includes('sb-atlas')) {
            setShowWizard1(true)
            dispatch(setShowInfo(false))
            localStorage.removeItem('token');
            localStorage.clear();
            sessionStorage.clear();
            dispatch(setToken(undefined));
            dispatch(setUser(undefined));
        } else if (!token && !localStorage.getItem('token')) {
            hasEDevletStatus();
        }
    }, [])

    useEffect(() => {
        isLoggedIn();
        if (token) {
            getFuntionalAuthorizations();
            getZoneAuthorizations();
            getDataAuthorizations();
            getUser()
            if (!localStorage.getItem('warningDisplayed') || localStorage.getItem('warningDisplayed') === 'false') {
                setShowToastOnLoad(true)
            }
            else {
                setShowToastOnLoad(false)
            }
            localStorage.setItem('warningDisplayed', 'true')
        } else if (!token && localStorage.getItem('token')) {
            dispatch(setToken(localStorage.getItem('token')));
        }

    }, [token, activeLanguage])

   

    useEffect(() => {
        const currentURL = window.location.href;
        if (activeLanguage !== 'tr' && activeLanguage !== 'eng') {
            localStorage.setItem('activeLanguage', 'tr')
        }
        if (currentURL.includes('sb-atlas')) {
            setTimeout(() => {
                localStorage.setItem('activeLanguage', activeLanguage)
            }, 3000);
        }
    }, [activeLanguage])

    useEffect(() => {
        if (showToastOnLoad) {
            toastSticky.current?.show({
                severity: 'info', summary: 'Uyarı', sticky: true,
                closable: false,
                content: (
                    <div className="flex flex-column" style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                        <div style={{ display: 'flex', alignItems: 'center' }} >
                            <div>
                                <i className="pi pi-info-circle" style={{ fontSize: '3rem', marginRight: '0.5em' }}></i>
                            </div>
                            <div>
                                <p style={{ fontSize: '17px' }}>Bu sayfada sunulan coğrafi ve sözel veriler bilgilendirme amaçlıdır. Resmi iş ve işlemlerde kullanılamaz. Destek için <strong style={{ color: '#b68a33' }}>meydip.destek@sanayi.gov.tr</strong> iletişim adresinden ulaşabilirsiniz.
                                </p>
                            </div>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <Button type="button" label="Tamam" className="ok-button" onClick={hideToast} />
                        </div>
                    </div>
                )
            });
        }
        else {
            hideToast()
        }
    }, [showToastOnLoad])

    useEffect(() => {
        if (showToast) {
            toastInfo.current?.show({
                severity: 'info', summary: 'Uyarı', sticky: true,
                closable: false,
                content: (
                    <div className="flex flex-column" style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                        <div style={{ display: 'flex', alignItems: 'center' }} >
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <i className="pi pi-info-circle" style={{ fontSize: '3rem', marginRight: '0.5em' }}></i>
                                <p style={{ fontSize: '17px' }}> İletişim: <strong style={{ color: '#b68a33' }}>meydip.destek@sanayi.gov.tr</strong>
                                </p>
                            </div>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <Button type="button" label="Tamam" className="ok-button" onClick={hideToast2} />
                        </div>
                    </div>
                )
            });
        }
        else {
            hideToast2()
        }
    }, [showToast])


    const hideToast = () => {
        toastSticky.current?.clear();
        setShowToastOnLoad(false)
    }
    const hideToast2 = () => {
        toastInfo.current?.clear();
        dispatch(setShowInfo(false))
    }


    useEffect(() => {
        if (activeLanguage === 'tr') {
            addLocale('tr', {
                startsWith: ['İle Başlayan'],
                contains: ['İçerir'],
                notContains: ['İçermez'],
                endsWith: ['İle Biten'],
                equals: ['Eşittir'],
                notEquals: ['Eşit Değildir'],
                lt: ['Küçüktür'],
                lte: ['Küçük Eşittir'],
                gt: ['Büyüktür'],
                gte: ['Büyük eşittir'],
                between: ['Arasında'],
                dateIs: ['Tarih eşittir'],
                dateIsNot: ['Tarih eşit değildir'],
                dateBefore: ['Tarihten öncesi'],
                dateAfter: ['Tarihten sonrası'],
                matchAll: ['Hepsini Eşleştir'],
                matchAny: ['Herhangi Biriyle Eşleştir'],
                addRule: ['Kural Ekle'],
                clear: ['Temizle'],
                apply: ['Uygula'],
                emptyMessage: ['Sonuç Bulunamadı.'],
                firstDayOfWeek: 0,
                dayNames: ['Pazartesi', 'Salı', 'Çarşamba', 'Perşembe', 'Cuma', 'Cumartesi', 'Pazar'],
                dayNamesShort: ["Pzt", "Sal", "Çar", "Per", "Cum", "Cmt", "Paz"],
                dayNamesMin: ["Pzt", "Sal", "Çar", "Per", "Cum", "Cmt", "Paz"],
                monthNames: ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'],
                monthNamesShort: ["Oca", "Şub", "Mar", "Nis", "May", "Haz", "Tem", "Ağu", "Eyl", "Eki", "Kas", "Ara"],
                today: 'Bugün',
            });
            locale('tr');
        } else {
            addLocale('eng', {
                startsWith: ['Starts with'],
                contains: ['Contains'],
                notContains: ['Not contains'],
                endsWith: ['Ends with'],
                equals: ['Equals'],
                notEquals: ['Not equals'],
                lt: ['Less than'],
                lte: ['Less than or equal to'],
                gt: ['Greater than'],
                gte: ['Greater than or equal to'],
                between: ['Between'],
                dateIs: ['Date is'],
                dateIsNot: ['Date is not'],
                dateBefore: ['Date before'],
                dateAfter: ['Date after'],
                matchAll: ['Match all'],
                matchAny: ['Match any'],
                addRule: ['Add Rule'],
                clear: ['Clear'],
                apply: ['Apply'],
                emptyMessage: ['No results found'],
            });
            locale('eng');
        }
    }, [activeLanguage])

    const isLoggedIn = () => {
        axios.interceptors.response.use(
            (successfulReq) => {
                dispatch(setShowLoading(false));
                return successfulReq;
            },
            (error: any) => {
                if (error?.response?.status === 401 && !window.location.href.includes('sb-atlas')) {
                    dispatch(setToken(undefined))
                    // navigate('login');
                    logout();
                }
                if (error?.response?.data?.message && !window.location.href.includes('sb-atlas')) {
                    toast.current?.show({ severity: 'error', summary: 'Error Message', detail: error.response.data.message, life: 3000 });
                }
                if (!error?.response?.data?.message && !window.location.href.includes('sb-atlas')) {
                    toast.current?.show({ severity: 'error', summary: 'Error Message', detail: `${t("MESSAGE.AxiosAutoError")} ${error.response.status}`, life: 3000 });
                }
                return Promise.reject(error);
            }
        );
    }

    const getUser = async () => {

        try {
            const response = await axios.get(process.env.REACT_APP_BASE_URL + `rest/v1/user/me?token=${token}`)
            if (response) {
                dispatch(setUser(response.data.user));
                if (!response.data.user.isactive) {
                    alert('Kullanıcı aktif değil')
                    dispatch(setToken(undefined))
                    localStorage.clear()
                    logout();
                }
            }
        } catch (error) {
        }
    }

    const hasEDevletStatus = async () => {
        // Fake Test
        // await LoginRestApi.tokenTest();
        const currentURL = window.location.href;

        if (!currentURL.includes('sb-atlas')) {
            let res;
            try {
                res = await LoginRestApi.loginEDevlet();
            } catch (error) {
                console.error(error);
            }

            if (res && res.data && res.data.success) {
                if (res.data.token) {
                    localStorage.setItem('token', res.data.token)
                    localStorage.setItem('selectedUserGroupId', res.data.defaultGroupId)
                    filterPermsByUserGroup(res.data.token, res.data.defaultGroupId)
                    dispatch(setUser(undefined));
                    navigate('/');
                    dispatch(setToken(res.data.token));
                    window.location.reload();
                }
            } else {
                navigate('/login');
            }
        }
    };

    const filterPermsByUserGroup = async (token: any, userGroupId?: any) => {
        localStorage.setItem('selectedUserGroupId', userGroupId)

        const body = {
            username: user.username,
            groupId: userGroupId.id
        }
        const response = await axios.post(process.env.REACT_APP_BASE_URL + `rest/v1/user/groupToken?token=${token}`, body)
        localStorage.setItem('token', response.data.token_with_group_id)
        dispatch(setToken(response.data.token_with_group_id))
        navigate("/");
    }


    const logout = async () => {
        if (token) {
            try {
                const localToken = localStorage.getItem('token');
                localStorage.removeItem('parselEditDisplayed');
                // localStorage.setItem('parselEditDisplayed', 'false');
                localStorage.clear();
                sessionStorage.clear();
                dispatch(setToken(undefined));
                dispatch(setUser(undefined));
                await LoginRestApi.logout(localToken!);
                navigate('/login');
                dispatch(setUser(undefined));
            } catch (error) {
                console.log(error);
            }
        } else {
            navigate('/login');
            localStorage.removeItem('parselEditDisplayed');
        }
    };

    const getFuntionalAuthorizations = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_BASE_URL}rest/v1/role/functional?token=${token}`)
            dispatch(setFunctionalRoles(response.data.functions));
        } catch (error) {
            console.error(error);
        }
    }

    const getZoneAuthorizations = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_BASE_URL}rest/v1/zone-role/zone/perm?token=${token}`)
            dispatch(setZoneRoles(response.data.zoneRoles));
        } catch (error) {
            console.error(error);
        }
    }

    const getDataAuthorizations = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_BASE_URL}rest/v1/util/permissions?token=${token}`)
            dispatch(setDataRoles(response.data.permissions));
        } catch (error) {
            console.error(error);
        }
    }


    return (
        <>
            <div className={`${showWizard1 || showWizard2 || showWizard3 || showWizard4 || showWizard5 || showWizard6 ? 'home control' : 'home'}`}>
                <LoadingScreen></LoadingScreen>
                <Layers zindex={showWizard3 ? true : false}></Layers>
                <Search zindex={{ search: showWizard2, categorical: showWizard4 }}></Search>
                <Toolbar zindex={{ other: showWizard5, tahsis: showWizard6 }} ></Toolbar>
                <InfoPanel></InfoPanel>
                <Basemap />
                {displayImport && <Import></Import>}
                {displayRapor && <Rapor></Rapor>}
                <Splitter gutterSize={displayPano ? 5 : 0} style={{ height: tableLayer ? '66%' : '100%' }} layout="horizontal">
                    <SplitterPanel>
                        <MapContainer></MapContainer>
                    </SplitterPanel>
                    <SplitterPanel className={`${!displayPano ? 'panorama-closed' : ''}`}>
                        <PanoramaContainer></PanoramaContainer>
                    </SplitterPanel>
                </Splitter>
                {
                    tableLayer &&
                    <Table layer={tableLayer}></Table>
                }
                <Toast ref={toast} position="bottom-center" style={{ zIndex: '9 !important' }}></Toast>
                {showToastOnLoad &&
                    <Toast className='warn-toast' ref={toastSticky} position="top-center" style={{ zIndex: '9 !important' }}></Toast>
                }
                {showToast &&
                    <Toast className='warn-toast2' ref={toastInfo} position="top-center" style={{ zIndex: '9 !important' }}></Toast>
                }
            </div>
            {showWizard1 &&
                <div className='w-container'>
                    <div className='wizard-container1'>
                        <p>
                            Yardım sihirbazını tamamlamak için lütfen ilerleyiniz.
                        </p>
                        <div className="buttons-container">
                            <Button label='İleri' className='wizard-button' onClick={() => { setShowWizard1(false); setShowWizard2(true); }} />
                            {/* <Button label='Geri' className='wizard-button'  onClick={()=> {setShowWizard1(false); setShowWizard1(true);}}/> */}
                            <Button label='Geç' className='wizard-button' onClick={() => {
                                setShowWizard1(false); setShowToastOnLoad(true);

                            }} />
                        </div>
                    </div>
                </div>
            }
            {showWizard2 &&
                <div className='container'>

                    <div className='wizard-container2'>
                        <p>
                            OSB/EB/TGB isimlerini yazarak arama yapabilirsiniz.
                        </p>
                        <div className="buttons-container">
                            <Button label='Geri' className='wizard-button' onClick={() => { setShowWizard2(false); setShowWizard1(true); }} />
                            <Button label='İleri' className='wizard-button' onClick={() => { setShowWizard2(false); setShowWizard3(true); }} />
                            <Button label='Geç' className='wizard-button' onClick={() => {
                                setShowWizard2(false); setShowToastOnLoad(true);
                            }} />
                        </div>
                    </div>
                </div>

            }
            {showWizard3 &&
                <div className='container'>

                    <div className='wizard-container3'>
                        <p>
                            Buradan katmanları açıp harita üzerinde istediğiniz <br /> katmana tıklayarak bilgi alabilirsiniz.
                        </p>
                        <div className="buttons-container">
                            <Button label='Geri' className='wizard-button' onClick={() => { setShowWizard3(false); setShowWizard2(true); }} />
                            <Button label='İleri' className='wizard-button' onClick={() => { setShowWizard3(false); setShowWizard4(true); }} />
                            <Button label='Geç' className='wizard-button' onClick={() => {
                                setShowWizard3(false); setShowToastOnLoad(true);
                            }} />
                        </div>
                    </div>
                </div>

            }
            {showWizard4 &&
                <div className='container'>

                    <div className='wizard-container4'>
                        <p>
                            Kategorik arama aracı ile parsel özelliklerini veya firma ismini <br /> yazarak parsel arayabilirsiniz.
                        </p>
                        <div className="buttons-container">
                            <Button label='Geri' className='wizard-button' onClick={() => { setShowWizard4(false); setShowWizard3(true); }} />
                            <Button label='İleri' className='wizard-button' onClick={() => { setShowWizard4(false); setShowWizard5(true); }} />
                            <Button label='Geç' className='wizard-button' onClick={() => {
                                setShowWizard4(false); setShowToastOnLoad(true);
                            }} />
                        </div>
                    </div>
                </div>

            }
            {showWizard5 &&
                <div className='container'>

                    <div className='wizard-container5'>
                        <p>
                            Ölçüm, yardım ve dil seçenekleri için bu araçları kullanabilirsiniz.
                        </p>
                        <div className="buttons-container">
                            <Button label='Geri' className='wizard-button' onClick={() => { setShowWizard5(false); setShowWizard4(true) }} />
                            <Button label='İleri' className='wizard-button' onClick={() => { setShowWizard5(false); setShowWizard6(true); }} />
                            <Button label='Geç' className='wizard-button' onClick={() => {
                                setShowWizard5(false); setShowToastOnLoad(true);
                            }} />
                        </div>
                    </div>

                </div>
            }
            {showWizard6 &&
                <div className='container'>

                    <div className='wizard-container5'>
                        <p>
                            Tahsis edilecek parsele karar verdiğinizde tahsis aracını kullanabilirsiniz.
                        </p>
                        <div className="buttons-container">
                            <Button label='Geri' className='wizard-button' onClick={() => { setShowWizard6(false); setShowWizard5(true) }} />
                            <Button label='Bitir' className='wizard-button' onClick={() => {
                                setShowWizard6(false); setShowToastOnLoad(true);
                            }} />
                            <Button label='Geç' className='wizard-button' onClick={() => {
                                setShowWizard6(false); setShowToastOnLoad(true);

                            }} />
                        </div>
                    </div>
                </div>

            }
        </>
    )
}
